module.exports = __webpack_public_path__ + "img/20191026151434360截图20191026142018272.6f8e9e8e.jpg";